
export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-focus-line',
      title: 'ビジョンが明確になる',
      description: '漠然としていた夢や目標が、具体的なイメージとして明確になります。何を目指すべきかがはっきりします。'
    },
    {
      icon: 'ri-run-line',
      title: '行動ができるようになる',
      description: 'ビジョンが明確になることで、次に何をすべきかが見えてきます。迷いなく行動できるようになります。'
    },
    {
      icon: 'ri-heart-line',
      title: '自己価値が高まる',
      description: '自分の本当の望みに気づくことで、自己理解が深まります。自信を持って前に進めるようになります。'
    },
    {
      icon: 'ri-emotion-happy-line',
      title: '人生の楽しさを体験',
      description: '夢を描くプロセス自体が楽しく、ワクワクする体験です。人生をより豊かに楽しめるようになります。'
    },
    {
      icon: 'ri-team-line',
      title: '仲間との出会い',
      description: '同じ志を持つ仲間と出会えます。お互いの夢を応援し合える関係が築けます。'
    },
    {
      icon: 'ri-compass-line',
      title: '人生の方向性が定まる',
      description: '迷いや不安が減り、自分の進むべき道が見えてきます。人生の羅針盤を手に入れられます。'
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            セミナーで得られる効果
          </h3>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            このセミナーに参加することで、あなたの人生に大きな変化が訪れます
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-500 rounded-xl flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h4>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
